// Builder servisních QR kódů. Single source of truth pro mapování
// ServiceVariant → QR payload string (kontrakt s HW čtečkou bzuco_reader,
// viz src/app/screen_intro.py).

export type DisplayPercent = 20 | 40 | 60 | 80 | 100
export type LanguageCode = 'cs' | 'en' | 'sk' | 'de' | 'pl' | 'hu' | 'hr'
export type ScanInfoMode = 'NONE' | 'PRICE' | 'TICKETSET' | 'TICKETSET-PRICE'

export type ServiceVariant =
    | { kind: 'server';       variant: 'prod' | 'test' }
    | { kind: 'counter';      variant: 0 | 1 }
    | { kind: 'display';      variant: DisplayPercent }
    | { kind: 'language';     variant: LanguageCode }
    | { kind: 'scan-info';    variant: ScanInfoMode }
    | { kind: 'wifi';         variant: { ssid: string; password: string } }
    | { kind: 'start-update' }
    | { kind: 'reset' }

export type ServiceKind = ServiceVariant['kind']

// WIFI QR special characters that must be backslash-escaped per the standard
// (\, ;, ,, :, " — see https://en.wikipedia.org/wiki/QR_code#Joining_a_Wi-Fi_network).
function escapeWifiField(value: string): string {
    return value.replace(/([\\;,:"])/g, '\\$1')
}

// HW čtečka (bzuco_reader, src/app/screen_intro.py) vyžaduje koncový středník
// jako terminátor — bez něj parser na čtečce padá.
export function renderServiceCode(s: ServiceVariant): string {
    switch (s.kind) {
        case 'server':       return `SERVER:T:${s.variant};`
        case 'counter':      return `COUNTER:T:${s.variant};`
        case 'display':      return `DISPLAY:I:${s.variant};`
        case 'language':     return `LANGUAGE:T:${s.variant};`
        case 'scan-info':    return `SCAN-INFO:T:${s.variant};`
        case 'wifi':         return `WIFI:T:WPA;S:${escapeWifiField(s.variant.ssid)};P:${escapeWifiField(s.variant.password)};`
        case 'start-update': return 'START-UPDATE;'
        case 'reset':        return 'RESET-ZIESAHS1;'
    }
}
